import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { API_BASE_URL } from '../../config/api-config';

interface DevLoginResponse {
  token: string;
}

/**
 * TEST-ONLY login client for FiveWORX.Communication.API.Controllers.DevAuthController.
 * That endpoint 404s outside the API's own Development environment -- this service has no
 * client-side awareness of environment and simply surfaces whatever the server returns
 * (a 404 there reads to this login page as "invalid username or password", which is
 * accurate enough for a test-only screen). Replace with the real external Authenticator
 * Service's own login/redirect flow when that integration happens; AuthCallbackComponent
 * already exists for that and is untouched by this.
 */
@Injectable({ providedIn: 'root' })
export class DevAuthApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(API_BASE_URL);

  login(username: string, password: string): Observable<DevLoginResponse> {
    return this.http.post<DevLoginResponse>(`${this.baseUrl}/auth/dev-login`, { username, password });
  }
}
